import type { ComponentProps } from "react";

import {
  getHistoryPageNavbarActionsClassName,
  getHistoryPageNavbarGridClassName,
  getHistoryPageNavbarMetadataClassName,
  getHistoryPageNavbarResourceLinksClassName,
} from "./historyPageNavbarLayout";

import { Skeleton } from "@/components/ui/skeleton";

const shimmerClassName = "from-gray-100 via-gray-200 to-gray-100";

const Shimmer = (props: ComponentProps<typeof Skeleton>) => (
  <Skeleton className={shimmerClassName} {...props} />
);

export const HistoryPageNavbarLoadingShimmer = ({
  compactTitle = false,
}: {
  compactTitle?: boolean;
}) => (
  <div aria-hidden="true" className="flex flex-1 flex-col gap-4 px-4 pb-4 md:px-0">
    <div className={getHistoryPageNavbarGridClassName(compactTitle)}>
      <div className="flex min-w-0 items-center gap-2">
        <Shimmer
          width={compactTitle ? 140 : 160}
          height={compactTitle ? 24 : 28}
          borderRadius="4px"
        />
        <Shimmer width={24} height={24} borderRadius="4px" />
      </div>
      <div className={getHistoryPageNavbarActionsClassName(compactTitle)}>
        <Shimmer width={120} height={16} borderRadius="3px" />
        <Shimmer width={104} height={16} borderRadius="3px" />
        <Shimmer width={36} height={36} borderRadius="6px" />
        <Shimmer width={36} height={36} borderRadius="6px" />
      </div>
      <div className={getHistoryPageNavbarMetadataClassName()}>
        <Shimmer width={200} height={14} borderRadius="3px" />
        <div className="hidden h-1 w-1 shrink-0 rounded-full bg-gray-200 sm:block" />
        <Shimmer width={160} height={14} borderRadius="3px" />
      </div>
      <div className={getHistoryPageNavbarResourceLinksClassName()}>
        <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
          <Shimmer width={140} height={12} borderRadius="3px" />
          <Shimmer width={100} height={12} borderRadius="3px" />
        </div>
      </div>
    </div>
  </div>
);
